import { DataBean } from "../DataBean";

export class TechnicalSkillProduct extends DataBean {


    public async getTechnicalSkillProductCatalog(idTechnicalSkillType: number | null): Promise<any> {
        return this.getCustomService("PeopleArt", "java.util.List_getTechnicalSkillProductCatalog_Number", [idTechnicalSkillType]);
    }

}